import store from 'state/RootReducer';
import { RestEnds } from '../Constants';
import { AuthActions } from 'state/authentication/Action';
import axios, { CanceledError } from 'axios';

const AxiosManager = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

const getAccessToken = (): string => store.getState().authState.accessToken;
const getRefreshToken = (): string => store.getState().authState.refreshToken;

/**
 *  Used to modify the request headers common for all requests
 */
AxiosManager.interceptors.request.use((configInfo: any) => {
  const config = configInfo;
  // Append auth header
  if (
    config.headers['append-auth-header'] === 'true' &&
    getAccessToken() !== ''
  ) {
    config.headers['x-auth-token'] = `bearer ${getAccessToken()}`;
  }
  return config;
});

// To refresh accessToken and retry failed requests
let isAlreadyFetchingAccessToken = false;
let subscribers: any[] = [];
const onAccessTokenFetched = (accessToken: string): void => {
  subscribers = subscribers.filter((callback) => callback(accessToken));
};

const addSubscriber = (callback: any): void => {
  subscribers.push(callback);
};

const logout = (): void => {
  store.dispatch(AuthActions.doLogout({}));
};

// Function that will be called to refresh authorization
export const refreshAccessToken = (): any =>
  AxiosManager.post(
    RestEnds.REFRESH_TOKEN,
    {},
    {
      headers: {
        'x-auth-token': `bearer ${getRefreshToken()}`,
      },
    }
  )
    .then((response: any) => {
      const { accessToken, refreshToken } = response.data.data;
      store.dispatch(AuthActions.setLoginStatus({ accessToken, refreshToken }));
      isAlreadyFetchingAccessToken = false;
      onAccessTokenFetched(accessToken);
    })
    .catch(() => {
      isAlreadyFetchingAccessToken = false;
      subscribers = [];
      logout();
    });

// AxiosManager.interceptors.request.use((response) => response);

AxiosManager.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error instanceof CanceledError === false) {
      console.log(error);
      const {
        config,
        response: { status },
      } = error;
      const originalRequest = config;
      if (
        status === 401 &&
        config.url !== RestEnds.REFRESH_TOKEN &&
        config.url !== RestEnds.LOGOUT &&
        config.url !== RestEnds.LOGIN
      ) {
        if (!isAlreadyFetchingAccessToken) {
          isAlreadyFetchingAccessToken = true;
          return new Promise((resolve) => {
            addSubscriber((accessToken: string) => {
              originalRequest.headers['x-auth-token'] = `bearer ${accessToken}`;
              resolve(AxiosManager(originalRequest));
            });
            refreshAccessToken();
          });
        }
        // exclusion
        return new Promise((resolve) => {
          addSubscriber((accessToken: string) => {
            originalRequest.headers['x-auth-token'] = `bearer ${accessToken}`;
            resolve(AxiosManager(originalRequest));
          });
        });
      }
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);

const { CancelToken: cancelation, Cancel } = axios;

export const CancelToken = cancelation;
export const CancelStatic = Cancel;

export default AxiosManager;
